export enum ConfType {
    STATUS_IN_TRANSPORT = 'status_in_transport',
    STATUS_DELIVERED = 'status_delivered',
    PROTOCOL = 'protocol',
    PROTOCOL_NO_PHOTOS = 'protocol_no_photos',
    PROTOCOL_DRAFT = 'protocol_draft',
    PROTOCOL_SAVE_DRAFT = 'protocol_save_draft',
    PROTOCOL_SUCCESS_SAVE_DRAFT = 'protocol_success_save_draft',
    CANCEL_SIGNATURE = 'cancel_signature',
    START_SHIFT = 'start_shift',
    END_SHIFT = 'end_shift',
    START_STOP_TRACKING = 'start_stop_tracking',
    END_STOP_TRACKING = 'end_stop_tracking',
    END_STOP_TRACKING_UNFINISHED = 'end_stop_tracking_unfinished',
    END_STOP_TRACKING_PREVIOUS = 'end_stop_tracking_previous',
    START_BREAK = 'start_break',
    END_BREAK = 'end_break',
    DATA_REFRESHED = 'data_refreshed',
    EDIT_SHIFT = 'edit_shift',
    EDIT_SHIFT_BREAK = 'edit_shift_break',
    EDIT_TOUR_STOP_TRACKING = 'edit_tour_stop_tracking',
    COMPLETE_LINK_ACTION = 'complete_link_action',
    FUEL_REFILL = 'fuel_refill',
    SEARCH_MACHINE = 'search_machine',
    SWITCH_MACHINE = 'switch_machine',
    CANCEL_CONFIRMATION = 'CANCEL_CONFIRMATION',
    COMPLETE_VENDOR_ACTION = 'COMPLETE_VENDOR_ACTION',
    UNTRACKED_STOP_WARNING = 'untracked_stop_warning',
    UNTRACKED_STOP_WARNING_OK = 'untracked_stop_warning_ok',
    UNTRACKED_STOP_WARNING_CANCEL = 'untracked_stop_warning_cancel',
    DELETE_PROTOCOL_DAMAGE_COMMENT = 'delete_protocol_damage_comment',
    ACCEPT_DELETE_PROTOCOL_DAMAGE_COMMENT = 'accept_delete_protocol_damage_comment',
    REJECT_DELETE_PROTOCOL_DAMAGE_COMMENT = 'reject_delete_protocol_damage_comment',
    NAME_ADDED = 'name_added',
}
